export default ({ theme }) => ({
    '> .ant-layout-header': {
        display: 'flex',
        height: `${theme.sizes.header}rem`,
    },
    '> .ant-layout-header .ant-menu': {
        lineHeight: `${theme.sizes.header}rem`,
        flexGrow: 1,
    },
});
